// @flow

import styled from 'styled-components'

// The crash screen lives outside the app theme and GlobalStyle, which set the rem scale,
// so sizes are given in "px of a 1920 wide screen" and converted to vw here.
// No gap, inset or CSS variables: webOS 3 runs Chrome 38.
const size = (px: number): string => `${px * 0.052}vw`

export const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background-color: #0f0f0f;
  color: rgba(255, 255, 255, 0.87);
  font-family: 'Lato', Arial, sans-serif;
`

// Upper part of the screen: keeps the button clear of the support block below
export const Content = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: ${size(760)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const Icon = styled.svg`
  width: ${size(120)};
  height: ${size(120)};
  margin-bottom: ${size(48)};
  color: ${({ $color }) => $color};
`

export const Title = styled.div`
  font-size: ${size(55)};
`

export const Subtitle = styled.div`
  max-width: ${size(1240)};
  margin-top: ${size(20)};
  font-size: ${size(34)};
  line-height: ${size(48)};
  color: rgba(255, 255, 255, 0.6);
`

export const ReloadButton = styled.button`
  min-width: ${size(320)};
  margin-top: ${size(56)};
  padding: ${size(22)} ${size(40)};
  border: 0;
  border-radius: ${size(8)};
  outline: none;
  background-color: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  font-family: inherit;
  font-size: ${size(30)};
  font-weight: 700;
  letter-spacing: ${size(1)};
  text-transform: uppercase;
  cursor: pointer;
`

// Non-interactive. Its box is as tall as the QR, so the transparent area above
// the support lines covers the reload button: let clicks pass through
export const Support = styled.div`
  position: absolute;
  right: ${size(64)};
  bottom: ${size(56)};
  display: flex;
  align-items: flex-end;
  pointer-events: none;
`

export const SupportText = styled.div`
  margin-right: ${size(28)};
  text-align: right;
`

export const SupportLabel = styled.div`
  margin-bottom: ${size(10)};
  font-size: ${size(24)};
  color: rgba(255, 255, 255, 0.6);
`

export const SupportLine = styled.div`
  font-family: Menlo, Consolas, 'Courier New', monospace;
  font-size: ${size(24)};
  line-height: ${size(34)};
  color: rgba(255, 255, 255, 0.38);
  white-space: nowrap;
  direction: ltr;
  unicode-bidi: embed;
`

export const QRBox = styled.div`
  width: ${size(450)};
  height: ${size(450)};
  background-color: #fff;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`

// Dev builds only; bottom-left, away from the button and the support block
export const DevDetails = styled.pre`
  position: absolute;
  left: ${size(64)};
  bottom: ${size(56)};
  width: ${size(560)};
  max-height: ${size(450)};
  margin: 0;
  overflow: auto;
  font-size: ${size(14)};
  line-height: ${size(20)};
  color: rgba(255, 255, 255, 0.6);
  white-space: pre-wrap;
  word-break: break-all;
`
